import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueCookies from 'vue-cookies'
import { format, parseISO } from 'date-fns'

import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueReCaptcha, { siteKey: '6Le3hqUUAAAAAERJKUWPxquAWYD7s1ev3HcVz1K_' })

Vue.use(VueCookies)

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return format(parseISO(value), 'PPPp')
  }
});
Vue.filter('formatTime', function (value) {
  if (value) {
    return format(parseISO(value), 'h:mm a')
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
